export const GAME_CONFIG = {
  rescueTime: 15,
  enableAnimals: true,
  enableHumans: true,
  enableToolSwitching: true,
  enablePhysics: true,
  enableCameraShake: true,
  enableAudio: true,
  nonGraphicMode: true,
  maxSecondaryAttempts: 2,
  riverSpeedMin: 0.6,
  riverSpeedMax: 3.8,
  windStrengthMin: 0,
  windStrengthMax: 1.8,
  difficulty: 'normal',
  toolSwitchPenalty: 1.25,
  maxScore: 1000,
} as const;

export type Difficulty = 'easy' | 'normal' | 'hard' | 'strict';
